module.exports = () => ({
  scope: {
    label: '@',
    requiredMessage: '@',
  },
  restrict: 'E',
  require: ['dateField', 'ngModel'],
  controllerAs: 'dateField',
  controller: class DateFieldController {

    static $inject = [
      '$translate',
    ];

    options = {
      months: moment.months(),
    };

    date = {
      day: null,
      month: null,
      year: null,
    };

    constructor($translate) {
      this.$translate = $translate;
    }

    $onInit() {
      this.locale = this.$translate.use();
    }

    validate() {
      if (this.date.day && this.date.month && this.date.year) {
        const dateInputMoment = moment(`${this.date.year} ${this.date.month} ${this.date.day}`, 'YYYY M D', true);

        // Check for valid date and date is in the past
        if (dateInputMoment.isValid() && !dateInputMoment.isAfter(moment())) {
          // we don't want to disable the save button if the year is <= 1900
          this.ngModel.$setValidity('format', this.date.year > 1900);
          return true;
        }
        this.ngModel.$setValidity('format', false);
        return false;
      }

      return false;
    }

    dateChanged = () => {
      if (this.validate()) {
        // If date is valid, update parent ngModel with new value (YYYY-MM-DD)
        this.ngModel.$setViewValue(moment(`${this.date.year} ${this.date.month} ${this.date.day}`, 'YYYY M D', true).format('YYYY-MM-DD'));
      }
    }

    setDate(date) {
      if (date) {
        const momentDate = moment(date, 'YYYY-MM-DD');

        this.date.day = momentDate.date();
        this.date.month = String(momentDate.month() + 1);
        this.date.year = momentDate.year();
      } else {
        this.date = {
          day: null,
          month: null,
          year: null,
        };
      }
    }

    get hasError() {
      return this.ngModel.$$parentForm.$submitted && this.ngModel.$invalid;
    }
  },
  link: (scope, element, attrs, controllers) => {
    const directiveController = controllers[0];
    const ngModel = controllers[1];

    // Bind ngModel to directive controller
    directiveController.ngModel = ngModel;

    // Watch ngModel value and update date stored in controller whenever it changes. Required to support initial ngModel value.
    // The listener will be called first when the form template is rendered, then each time $setViewValue() is called
    scope.$watch('dateField.ngModel.$modelValue', (newValue) => {
      directiveController.setDate(newValue);
    });
  },
  template: `
    <div class="field -multi" ng-class="{'-error': dateField.hasError}">
      <label>{{ label | translate }}</label>
      <div class="row">
        <div class="field day" ng-if="dateField.locale !== 'en'">
          <input class="day" type="text" name="day" ng-model="dateField.date.day" maxlength="2" placeholder="{{ 'signin.labels.day' | translate }}" ng-change="dateField.dateChanged()">
        </div><!--
        --><div class="field month">
          <select class="month" name="month" ng-model="dateField.date.month" ng-change="dateField.dateChanged()">
            <option selected translate="signin.labels.empty_state"></option>
            <option ng-repeat="month in dateField.options.months track by $index" value="{{ $index + 1 }}">{{ month }}</option>
          </select>
        </div><!--
        --><div class="field day -one-quarter" ng-if="dateField.locale === 'en'">
          <input class="day" type="text" name="day" ng-model="dateField.date.day" maxlength="2" placeholder="{{ 'signin.labels.day' | translate }}" ng-change="dateField.dateChanged()">
        </div><!--
        --><div class="field year">
          <input class="year" type="text" name="year" ng-model="dateField.date.year" maxlength="4" placeholder="{{ 'signin.labels.year' | translate }}" ng-change="dateField.dateChanged()">
        </div>
      </div>
      <div class="error-message" ng-show="dateField.hasError" ng-messages="dateField.ngModel.$error">
        <p ng-message="format" class="error">{{ 'signin.errors.date.invalid' | translate }}</p>
        <p ng-message="required" class="error">{{ requiredMessage | translate }}</p>
      </div>
    </div>
  `,
});



// WEBPACK FOOTER //
// ./main/directives/date-field.js